import {handleRepositoryDataError} from '@github-ui/data-router-error-helpers'
import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {RepoIssuesPageLayout} from '@github-ui/repo-issues-page-layout/RepoIssuesPageLayout'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'
import {RepositoryLabelsInternal} from '@github-ui/repository-label/RepositoryLabels'
import {Button} from '@primer/react'
import {useState} from 'react'

import {issuesLayoutRoute} from './issues-layout-route'
import {labelsRoute} from './labels-route'
import {useRenderSidebar} from './render-issues-sidebar'

export function Labels() {
  const {owner, repo} = useRouteParams(labelsRoute)
  const {data: layoutPayload} = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const payload = useRouteQuery(labelsRoute, 'mainQuery')

  const renderSidebarFn = useRenderSidebar(owner, repo, layoutPayload)

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false)
  const sidebarLayoutEnabled = useRepoIssuesSidebarLayoutEnabled()

  // on FORBIDDEN/SAML this reloads the page; otherwise it throws to the error boundary
  const data = handleRepositoryDataError(payload.data)

  // Flag off: the parent (IssuesLayout) owns the layout; this leaf is bare — identical to main.
  if (!sidebarLayoutEnabled) {
    // data is undefined only while a FORBIDDEN/SAML reload is in flight; render nothing until it lands
    if (!data?.repository) {
      return null
    }
    return <RepositoryLabelsInternal repository={data.repository} queryKey={payload.queryKey} />
  }

  // Flag on: this leaf owns the lifted layout and hoists its "New label" action into the header.
  const repository = data?.repository
  const headerActions = repository?.viewerCanPush ? (
    <Button variant="primary" onClick={() => setIsCreateDialogOpen(true)}>
      New label
    </Button>
  ) : undefined

  return (
    <BaseAnalyticsWrapper category="Repository Label Index" appName="issues">
      <RepoIssuesPageLayout
        dialogTitle="Labels"
        title="Labels"
        actions={headerActions}
        renderSidebar={renderSidebarFn}
        initialExpanded={layoutPayload?.sidebar_expanded ?? undefined}
      >
        {/* repository is undefined only while a FORBIDDEN/SAML reload is in flight; render the page chrome but suppress the labels UI until it lands */}
        {repository ? (
          <RepositoryLabelsInternal
            repository={repository}
            queryKey={payload.queryKey}
            isCreateDialogOpen={isCreateDialogOpen}
            onCreateDialogOpenChange={setIsCreateDialogOpen}
          />
        ) : null}
      </RepoIssuesPageLayout>
    </BaseAnalyticsWrapper>
  )
}
